module.exports = __webpack_public_path__ + "img/about_zhTc.d214ae1e.png";